<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-1">
                <h5 class="fw-semibold">{{'Market Information'| wordReplace }}</h5>
            </div>
            <hr />
            <div class="container-fluid">
                <form [formGroup]="marketSettingsForm" (ngSubmit)="saveMarketSettings()">
                    <div class="row">
                        <div class="col-md-12 col-lg-6 text-start mt-2">
                            <div class="container-fluid bg-white h-100">
                                <h6 class="fw-bold pt-3">Terms Used</h6>
                                <div class="row">
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="market" class="form-label">{{ 'Market' | wordReplace }}<span
                                                class="text-danger">*</span></label>
                                        <select class="form-select" id="market" formControlName="MarketTerm">
                                            <option [value]="null" disabled>Select</option>
                                            @for (m of marketTerms; track m.Id) {
                                            <option [value]="m.Id">{{ m.Name }}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="vendor" class="form-label">{{ 'Vendor' | wordReplace }}<span
                                                class="text-danger">*</span></label>
                                        <select class="form-select" id="vendor" formControlName="VendorTerm">
                                            <option [value]="null" disabled>Select</option>
                                            @for (v of vendorTerms; track v.Id) {
                                            <option [value]="v.Id">{{ v.Name }}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="booth" class="form-label">{{'Booth' | wordReplace }}<span
                                                class="text-danger">*</span></label>
                                        <select class="form-select" id="booth" formControlName="BoothTerm">
                                            <option [value]="null" disabled>Select</option>
                                            @for (b of boothTerms; track b.Id) {
                                            <option [value]="b.Id">{{ b.Name }}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <h6 class="fw-bold">{{ 'Market Details' | wordReplace }}</h6>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label for="corporateName" class="form-label">Corporate Name</label>
                                        <input type="text" class="form-control" id="corporateName" maxlength="50"
                                            formControlName="CorporateName">
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label for="marketName" class="form-label">{{ 'Market Name' | wordReplace }}
                                            <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="marketName" maxlength="100"
                                            formControlName="MarketName">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="city" class="form-label">City<span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="city" formControlName="MarketCity"
                                            maxlength="30">
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="state" class="form-label">State<span
                                                class="text-danger">*</span></label>
                                        <!-- Dropdown when states are available -->
                                        <select *ngIf="statesAvailable" id="state" class="form-select"
                                            formControlName="MarketStateCode">
                                            <option [value]="null" disabled>Select</option>
                                            @for (state of states; track state.StateCode) {
                                            <option [value]="state.StateCode">{{ state.StateName }}</option>
                                            }
                                        </select>
                                        <!-- Input when no states are available -->
                                        <input *ngIf="!statesAvailable" id="state" type="text" class="form-control"
                                            formControlName="MarketStateCode" placeholder="Enter State"
                                            maxlength="30" />
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="zipcode" class="form-label">ZipCode<span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="zipcode"
                                            formControlName="MarketZipCode" maxlength="10">
                                    </div>
                                    <div class="col-md-6 cl-lg-8 mb-2">
                                        <label for="address" class="form-label">Address</label>
                                        <textarea class="form-control" id="address" rows="2"
                                            formControlName="MarketAddress" maxlength="100"></textarea>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-2">
                                        <label for="country" class="form-label">Country</label>
                                        <select class="form-select" id="country" formControlName="MarketCountryCode"
                                            (change)="onCountryChange($event)">
                                            <option [value]="null" disabled>Select</option>
                                            @for (c of countries; track c.Code) {
                                            <option [value]="c.Code">{{ c.Name }}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6 text-start mt-2">
                            <div class="container-fluid bg-white h-100">
                                <h6 class="fw-bold pt-2">Contact Details</h6>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="email" class="form-label">Email Address</label>
                                        <input type="email" class="form-control" id="email"
                                            formControlName="EmailAddress" maxlength="50">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="facebook" class="form-label">Facebook ID</label>
                                        <input type="text" class="form-control" id="facebook"
                                            formControlName="FacebookId" maxlength="40">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="twitter" class="form-label">Twitter ID</label>
                                        <input type="text" class="form-control" id="twitter" formControlName="TwitterId"
                                            maxlength="40">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="web" class="form-label">Web Address</label>
                                        <input type="url" class="form-control" id="web" formControlName="WebAdress"
                                            maxlength="400">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="timezone" class="form-label">Timezone<span
                                                class="text-danger">*</span></label>
                                        <select class="form-select" id="timezone" formControlName="TimeZoneId">
                                            <option [value]="null" disabled>Select</option>
                                            @for (t of marketTimeZones ; track t.TimeZoneId) {
                                            <option [value]="t.TimeZoneId">{{ t.TimeZoneName }}</option>
                                            }
                                        </select>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="telephone" class="form-label">Telephone</label>
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="telephone" id="telephone"
                                            formControlName="Telephone"></ejs-maskedtextbox>
                                    </div>
                                </div>
                                <div class="row" [hidden]="true">
                                    <div class="col-md-6 mb-3">
                                        <label for="fax" class="form-label">Fax</label>
                                        <input type="text" class="form-control" id="fax" formControlName="Fax"
                                            maxlength="20" (keypress)="allowOnlyFaxChars($event)">
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-6 col-lg-4 text-start">
                                        <label class="form-label lblMarketLogo">{{ 'Market Logo' | wordReplace
                                            }}</label>
                                        <div class="logo-box mx-auto position-relative"
                                            style="margin-left: 0px !important;">
                                            <input *ngIf="isDefaultLogo" type="file" accept=".jpg,.jpeg,.png"
                                                (change)="addLogo($event)"
                                                class="form-control position-absolute top-0 start-0 w-100 h-100 opacity-0"
                                                style="cursor: pointer;">
                                            <div class="w-100 h-100 d-flex align-items-center justify-content-center "
                                                [ngClass]="{'no-photo': isNoPhoto}">
                                                <img [src]="logoPreviewUrl" id="logoPreview" class="img-fluid"
                                                    style="pointer-events: none;">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-8 text-start">
                                        <input type="file" id="logoFileInput" (change)="addLogo($event)"
                                            accept=".jpg,.jpeg,.png" hidden>
                                        <ejs-tooltip id='tooltipMLogoAdd' target="#btnMLogoAdd" position='RightCenter'
                                            openMode="Auto" windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                                            <button id="btnMLogoAdd" class="btn btnAS btn-sm mt-4" type="button"
                                                (click)="addLogoClick()"
                                                [userPermissionHandler]="editPermissionHandlerData">ADD</button>
                                        </ejs-tooltip>
                                        <br />
                                        <ejs-tooltip id='tooltipMLogoRemove' target="#btnMLogoRemove"
                                            position='RightCenter' openMode="Auto" windowCollision="fit"
                                            (beforeOpen)="onBeforeOpen($event)">
                                            <button id="btnMLogoRemove" class="btn btnAS btn-sm mt-2" type="button"
                                                (click)="removeLogo()" [disabled]="!canRemoveLogo"
                                                [userPermissionHandler]="editPermissionHandlerData">REMOVE</button>
                                        </ejs-tooltip>
                                        <br />
                                        <ejs-tooltip id='tooltipMLogoSave' target="#btnMLogoSave" position='RightCenter'
                                            openMode="Auto" windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                                            <button id="btnMLogoSave" class="btn btnAS btn-sm mt-2" type="button"
                                                (click)="saveMarketLogo()" [disabled]="!canSaveLogo"
                                                [userPermissionHandler]="editPermissionHandlerData">SAVE</button>
                                        </ejs-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-end my-2">
                            <ejs-tooltip id='tooltipMSave' target="#btnMarketSave" position='TopCenter' openMode="Auto"
                                windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                                <button id="btnMarketSave" type="submit" class="btn btnAS me-1"
                                    [userPermissionHandler]="editPermissionHandlerData">
                                    Save
                                </button></ejs-tooltip>
                            <button class="btn btn-orange" type="button" (click)="cancelChanges()">Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>